/**
 * 账变记录
 */
import { Fragment } from 'react';
import { connect } from 'react-redux';
import ReportWraper from '../commom/ReportWraper.jsx';
import DateSelector from '../../../../components/date/DateSelector.jsx';
import { TableLoader, TableEmpty } from '../../../../components/icon/Loader.jsx'
import Paginations from '../commom/Paginations.jsx';

class AccountCR extends React.Component {
  
  constructor(){
    super();
    this.types = [
      {value: '0', label: '所有类型'},
      {value: '1', label: '充值'},
      {value: '2', label: '提款'},
      {value: '3', label: '上下级转账'},
      {value: '4', label: '活动'},
      {value: '5', label: '日工资/返水'},
      {value: '6', label: '分红'},
      {value: '7', label: '第三方转账'},
      {value: '9', label: '钱包转账'},
      {value: '8', label: '其他'}
    ]
    this.status = [
      {value: '0', label: '所有状态'},
      {value: '1', label: '成功'},
      {value: '2', label: '失败'}
    ]
  }

  componentWillMount(){
    const query = {
      ordertype: '0',
      status: '0',
      starttime: $.momentDate().startOf('days').format('YYYY-MM-DD HH:mm'),
      endtime: $.momentDate().endOf('days').format('YYYY-MM-DD HH:mm'),
      pageNo: 1,
      userid: this.props.userid
    }
    this.props.setQuery(query)
  }

  search = (pageNo) => {
    this.props.setQuery({pageNo});
    const query = _.merge({}, {...this.props.querys, pageNo})
    this.props.$$DASH.getAccountCR(query)
  }
 
  render() {
    const { setQuery, querys } = this.props;
    const __accountRC = this.props.__DASH.toJS().accountCR;
    return (
      <Fragment>
        <div className="report-modal-header">
          账变记录
        </div>
        <div className="report-modal-content">
          <div className='search-bar'>
            从
            <div className='ib'>
              <select onChange={(e) => setQuery({ordertype: e.target.value})}>
                {
                  this.types.map(item => <option key={item.value} value={item.value}>{item.label}</option>)
                }
              </select>
            </div>
            <div className="ib">
              <select ref='status' onChange={(e) => setQuery({status: e.target.value})}>
                {
                  this.status.map(item => <option key={item.value} value={item.value}>{item.label}</option>)
                }
              </select>
            </div>
            <div className="ib">
              <DateSelector 
                minDate={$.momentDate().startOf('days').add(-16, 'days')} 
                start={querys.starttime} 
                end={querys.endtime} 
                cb={({start, end}) => setQuery({starttime: start, endtime: end})} 
                action={() => this.search(1)} 
              />
            </div>
          </div>
          <div className="table-cover" style={{height: '400px'}}>
            <table className='data' width="100%" border="0" cellSpacing="1" cellPadding="0" >
              <tbody>
                <tr>
                  <th>时间</th>
                  <th>用户名</th>
                  <th>账变编号</th>
                  <th>类型</th>
                  <th>收入</th>
                  <th>支出</th>
                  <th>余额</th>
                  <th>状态</th>
                  <th>备注</th>
                </tr>
                { !__accountRC && <TableLoader merge={9} />}
                { __accountRC && __accountRC.recordsCount == 0 && <TableEmpty merge={9} />}
                {
                  _.get(__accountRC, 'orders[0]') &&
                  <Fragment>
                    {
                      __accountRC.orders.map((item) => 
                        <tr key={item.orderno}>
                          <td>{item.times}</td>
                          <td>{this.props.username}</td>
                          <td>{item.orderno}</td>
                          <td>{item.cntitle}</td>
                          <td style={{color: '#669900'}}>{item.operations > 0 && $.formatMoney(item.amount, 4, '+')}</td>
                          <td style={{color: '#FF3300'}}>{item.operations == 0 && $.formatMoney(item.amount, 4, '-')}</td>
                          <td>{$.formatMoney(item.availablebalance, 4, '')}</td>
                          <td>{_.includes(['1','3'], item.transferstatus) ? '失败' : '成功'}</td>
                          <td>{_.includes(['4','40'], item.ordertypeid) ? item.description : '------'}</td>
                        </tr>  
                      )
                    }
                    <tr className='font-blod'>
                      <td colSpan="4"><b>本页合计</b></td>
                      <td style={{color: 'green'}}>+{$.formatMoney(__accountRC.summary.in, 4, '')}</td>
                      <td style={{color: 'red'}}>-{$.formatMoney(__accountRC.summary.out, 4, '')}</td>
                      <td>--</td>
                      <td>--</td>
                      <td>--</td>
                    </tr>
                  </Fragment>
                }
              </tbody>
            </table>
          </div>
          {
            _.get(__accountRC, 'orders[0]') &&
            <Paginations 
              pageNo={querys.pageNo} 
              pageSize={20} 
              count={__accountRC.recordsCount} 
              action={(pageNo) => this.search(pageNo)} 
            />
          }
        </div>
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    __DASH: state.dashboard
  };
}

function mapDispatchToProps(dispatch) {
  return {
    $$DASH: bindActionCreators(dashAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  };
}

var AccountCRConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountCR);

export default ReportWraper(AccountCRConnect, {destroy: ['accountCR']});